var _ellipse, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstancelogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 89,
    viewBox: "0 0 94 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.4289,
    cy: 9.36832,
    rx: 10.2313,
    ry: 9.36832,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 30.9303C0 27.4302 2.83735 24.5929 6.33739 24.5929H8.85936C26.3922 24.5929 40.6054 38.8061 40.6054 56.3389V80.847C40.6054 85.3499 36.9551 89.0001 32.4523 89.0001C27.9495 89.0001 24.2993 85.3499 24.2993 80.847V54.1582C24.2993 45.2673 17.0918 38.0599 8.201 38.0599H7.12956C3.19201 38.0599 0 34.8678 0 30.9303Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.66 59.7629C23.66 40.339 39.4062 24.5929 58.83 24.5929C78.2539 24.5929 94.0001 40.339 94.0001 59.7629V80.8471C94.0001 85.3499 90.3498 89.0001 85.847 89.0001C81.3442 89.0001 77.694 85.3499 77.694 80.8471V56.4442C77.694 46.2908 69.463 38.0599 59.3096 38.0599C49.1563 38.0599 40.9253 46.2908 40.9253 56.4442V80.3675C40.9253 85.1351 37.0603 89.0001 32.2927 89.0001C27.525 89.0001 23.66 85.1351 23.66 80.3675V59.7629Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstancelogo);
export default __webpack_public_path__ + "static/media/instancelogo.dfdde6f0153be03a77d44d978a83ea4f.svg";
export { ForwardRef as ReactComponent };